import { getAxiosInstance } from './axiosInstance'; 
const tagDeviceToVehicle = (data) => {
  const http = getAxiosInstance();
  return http.post("/api/tag/TagDevice2Vehicle/",data,{
    headers: {
      'Content-type': 'multipart/form-data',
    }
    });
};

const tagDeviceToVehicleComplete = (data) => {
  const http = getAxiosInstance();

  return http.post("/api/tag/TagDevice2VehicleComplete/", data, {
    headers: {
      "Content-type": "multipart/form-data",
    },
  });
};

const getDeviceTagInvoice = (params) => {
  const http = getAxiosInstance();

  return http.get('/api/reports/device-tag-invoice/', {
    params
  });
};

const tagAwaitingOwnerApproval = () => {
  const http = getAxiosInstance();
  return http.get(`/api/tag/TagAwaitingOwnerApproval/`);
};
const tagApprovedOwnerApproval = () => {
  const http = getAxiosInstance();
  return http.get(`/api/tag/TagAwaitingActivateTag/`);
};
const tagSendOwnerOtp = (data) => {
  const http = getAxiosInstance();
  return http.post("/api/tag/TagSendOwnerOtp/", data);
};
const tagVerifyOwnerOtp = (data) => {
  const http = getAxiosInstance();
  return http.post(`/api/tag/TagVerifyOwnerOtp/`, data);
};
const tagVerifyDealerOtp = (data) => {
  const http = getAxiosInstance();
  return http.post(`/api/tag/TagVerifyDealerOtp/`,data);
};
const uploadTagReceipt=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/upload_receiptPDF/',data);
}
const downloadTagReceipt=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/download_receiptPDF/',data,{
    responseType: "arraybuffer",
  });
}
const vahanVerificationApi=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/GetVahanAPIInfo/',data);
}
const activateTag=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/ActivateTag/',data);
}
const getTagAwaitingOwnerApprovalFinal=(data)=>{
  const http=getAxiosInstance();
  return http.get('/api/tag/TagAwaitingOwnerApprovalFinal/',{
    params:{
      device_id:data.device_id
    }
    }
    );
}
const sendTagSendOwnerOtpFinal=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/TagSendOwnerOtpFinal/',data);
}
const verifyTagVerifyOwnerOtpFinal=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/TagVerifyOwnerOtpFinal/',data);
}
const getTagStatus=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/tag_status/',data);
}
const getOwnerList=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/tag_ownerlist/',data)
}
const untagDevice=(tagId)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/untag/',tagId);
}
const retagDevice=(tagId)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/retag/',tagId);
}
const updateTempRegistration = (data) => {
  const http = getAxiosInstance();
  return http.post('/api/tag/update-temp-registration/', data, {
    headers: {
      'Content-type': 'multipart/form-data',
    },
  });
}
const cancelTagDevice=(deviceId)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/cancelTagDevice2Vehicle/',deviceId)
}
const gettaggedDeviceList=(data)=>{
  const http=getAxiosInstance();
  return http.post('/api/tag/StateAdmin_view_all_tagging/')
}

const getUntaggedDeviceStock = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/devicestock/deviceStockUntaggedList/",
    data
  );
};

const deleteDeviceStock = (stockIds) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/devicestock/deviceStockSoftDelete/",
    {
      stock_ids: stockIds,
    }
  );
};

const getGovernmentCertificationPendingList = (data) => {
  const http = getAxiosInstance();
  return http.post(
    "/api/tag/TagGovCertificationPendingList/",
    data
  );
};

const markGovernmentServerActivationDone = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagMarkGovServerActivationDone/",
    data,
    {
      headers: {
        "Content-type": "multipart/form-data",
      },
    }
  );
};

const checkLiveTracking = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagCheckLiveTracking/",
    data
  );
};

const sendSOSStartCommand = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagSendSOSStartCommand/",
    data
  );
};

const confirmSOSStart = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagConfirmSOSStart/",
    data
  );
};

const sendSOSStopCommand = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagSendSOSStopCommand/",
    data
  );
};

const confirmSOSStop = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagConfirmSOSStop/",
    data
  );
};

const verifyVehicleOwnerMobile = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/verifyVehicleOwnerMobile/",
    data
  );
};

const sendRegNoCommand = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagSendRegNoCommand/",
    data
  );
};

const confirmRegNoCommand = (data) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/tag/TagConfirmRegNoCommand/",
    data
  );
};

const getEligibleImeiList = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/devicestock/deviceStockFilterEligible/",
    {
      page: 1,
      page_size: 100,
      ...data,
    }
  );
};

const getExpiringSoonDevices = (data = {}) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/commercial/expiring-soon/",
    data
  );
};

const requestEsimExtension = (deviceStockIds) => {
  const http = getAxiosInstance();

  return http.post(
    "/api/stock/commercial/extend/",
    {
      device_stock_ids: deviceStockIds,
    }
  );
};

const TaggingService = {
    tagDeviceToVehicle,
    tagAwaitingOwnerApproval,
    tagSendOwnerOtp,
    tagVerifyOwnerOtp,
    tagVerifyDealerOtp,
    uploadTagReceipt,
    downloadTagReceipt,
    vahanVerificationApi,
    tagApprovedOwnerApproval,
    activateTag,
    getTagAwaitingOwnerApprovalFinal,
    sendTagSendOwnerOtpFinal,
    verifyTagVerifyOwnerOtpFinal,
    getTagStatus,
    getOwnerList,
    untagDevice,
    retagDevice,
    updateTempRegistration,
    cancelTagDevice,
    gettaggedDeviceList,
    tagDeviceToVehicleComplete,
    getDeviceTagInvoice,
getUntaggedDeviceStock,
  deleteDeviceStock,
  getGovernmentCertificationPendingList,
markGovernmentServerActivationDone,
checkLiveTracking,
sendSOSStartCommand,
confirmSOSStart,
sendSOSStopCommand,
confirmSOSStop,
verifyVehicleOwnerMobile,
sendRegNoCommand,
confirmRegNoCommand,
getEligibleImeiList,
getExpiringSoonDevices,
  requestEsimExtension,
};

export default TaggingService;
